import { ClipboardText } from "@phosphor-icons/react";
import { GROUP_META } from "@/lib/completeness";

// Franja: cuántos productos del listado están incompletos y qué les falta.
// Cada chip activa el filtro correspondiente.
export default function CompletenessSummary({ items, filter, onFilter }) {
  const total = items.length;
  if (total === 0) return null;
  const incomplete = items.filter((x) => !x.c.complete).length;
  const byGroup = Object.keys(GROUP_META).map((id) => ({ id, ...GROUP_META[id], n: items.filter((x) => x.c.missingGroups.includes(id)).length })).filter((g) => g.n > 0);
  const chip = (active, extra = "") => `inline-flex items-center gap-1 h-7 px-2.5 rounded-full border text-xs font-semibold transition-colors ${active ? "bg-[#002FA7] text-white border-[#002FA7]" : `bg-white border-zinc-200 text-zinc-700 hover:border-[#002FA7] hover:text-[#002FA7] ${extra}`}`;
  return (
    <div className="border border-zinc-200 bg-white px-3 py-2 flex flex-wrap items-center gap-2" data-testid="completeness-summary">
      <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-zinc-500 font-semibold mr-1"><ClipboardText size={14} weight="duotone" /> Completitud</span>
      <button type="button" onClick={() => onFilter("complete")} className={chip(filter === "complete")} data-testid="completeness-chip-complete">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" /> Completos <b className="numeric">{total - incomplete}</b>
      </button>
      <button type="button" onClick={() => onFilter("incomplete")} className={chip(filter === "incomplete")} data-testid="completeness-chip-incomplete">
        <span className="w-1.5 h-1.5 rounded-full bg-[#E0000F]" /> Falta algo <b className="numeric">{incomplete}</b>
      </button>
      {byGroup.length > 0 && <span className="text-zinc-300 hidden sm:inline">|</span>}
      {byGroup.map((g) => (
        <button type="button" key={g.id} onClick={() => onFilter(`missing_${g.id}`)} className={chip(filter === `missing_${g.id}`)} title={`${g.n} producto(s) sin ${g.label.toLowerCase()} completo`} data-testid={`completeness-chip-${g.id}`}>
          Sin {g.label.toLowerCase()} <b className="numeric">{g.n}</b>
        </button>
      ))}
      {filter !== "all" && (
        <button type="button" onClick={() => onFilter("all")} className="ml-auto text-xs text-zinc-500 hover:text-[#002FA7] underline-offset-2 hover:underline" data-testid="completeness-clear">Ver todos</button>
      )}
    </div>
  );
}
